import React, { Suspense } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import { ProvideConfiguration } from './ConfigContext';
import { BasePage } from './base-page/BasePage';
import { Loading } from './_shared/loading/Loading';

export function App(): JSX.Element {
  return (
    <Suspense fallback={<Loading />}>
      <ProvideConfiguration>
        <Router>
          <BasePage />
        </Router>
      </ProvideConfiguration>
    </Suspense>
  );
}
